// vendors
import React, { useState, createRef, useEffect } from "react"
import { css } from "@emotion/core"
import { colors, fontSizes, fonts, transition } from "../../styles/variables"
import mediaQuery from "../../utils/media-query"
import wrapper from "../../utils/wrapper"

const Accordion = ({
  breakpoint = 1024,
  children,
  header,
  title,
  ...props
}) => {
  const [height, setHeight] = useState(0)
  const [isOpen, setIsOpen] = useState(false)

  let textContainer = createRef()

  const handleClick = () => {
    let textContainerHeight = 0

    if (textContainer.current) {
      textContainerHeight = textContainer.current.scrollHeight
    }

    setIsOpen(!isOpen)
    setHeight(!isOpen ? textContainerHeight : 0)
  }
  const handleResize = () => {
    let textContainerHeight = height

    if (textContainer.current) {
      textContainerHeight = textContainer.current.scrollHeight
    }

    setHeight(isOpen ? textContainerHeight : 0)
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize ", handleResize)
    }
  })

  return (
    <div
      css={css`
        padding-top: ${fontSizes[5] / fontSizes[0]}em;
        padding-bottom: ${fontSizes[5] / fontSizes[0]}em;
        background-color: ${colors.offWhite};

        ${mediaQuery.lessThen(breakpoint)} {
          ${wrapper.bolt("padding")};
        }

        ${mediaQuery.greaterThen(breakpoint)} {
          padding: ${fontSizes[5] / fontSizes[0]}em;
        }
      `}
      {...props}
    >
      <div
        onClick={() => handleClick()}
        role="button"
        tabIndex="0"
        onKeyPress={() => handleClick()}
        css={css`
          cursor: pointer;
          display: flex;
          flex-wrap: wrap;
        `}
      >
        <div
          css={css`
            flex-grow: 999;
            flex-basis: 30em;
            display: flex;
            align-items: center;
          `}
        >
          {header && header}

          {!header && title && (
            <p
              css={css`
                margin: 0;
              `}
            >
              {title}
            </p>
          )}
        </div>

        <div
          css={css`
            flex-grow: 1;
            flex-basis: 0;
            text-align: right;
            margin-left: ${fontSizes[8] / fontSizes[3]}em;
          `}
        >
          <button
            onClick={() => handleClick()}
            type="button"
            tabIndex="-1"
            css={css`
              text-align: center;
              padding: 0;
              margin: 0;
              cursor: pointer;
              font-family: ${fonts.accent};
              appearance: none;
              border: 0;
              width: 40px !important;
              height: 40px;
              color: ${colors.offWhite};
              border-radius: 50%;
              font-size: ${fontSizes[3]}px;
              line-height: 0;
              transition: all ${transition.speed.slow}
                ${transition.curve.default};

              ${isOpen
                ? css`
                    transform: rotate(90deg);
                    background-color: ${colors.blueyGreen};
                  `
                : css`
                    transform: rotate(0deg);
                    background-color: ${colors.pastelRed};
                  `}
            `}
          >
            →
          </button>
        </div>
      </div>

      <div
        ref={textContainer}
        css={css`
          transition: height ${transition.speed.slow}
            ${transition.curve.default};
          height: 0;
          overflow: Hidden;
          transform-origin: top;
        `}
        style={{ height }}
      >
        <div
          css={css`
            margin-top: ${fontSizes[3] / fontSizes[0]}em;
          `}
        >
          {children}
        </div>
      </div>
    </div>
  )
}

export default Accordion
